import { Events } from '@/utils/servicesEvents'
import { Network } from '@/utils/network'
import { Formatter } from '../../formatter'

import urls from '../urls.json'

async function getRates(onSuccessEvent, onErrorEvent) {
  const response = await sendRequest()
  const parsedResponse = parseResponse(response, Formatter)
  const event = parsedResponse.statusCode == 200 ? onSuccessEvent : onErrorEvent
  Events.dispatchEvent(event, parsedResponse)
}

async function sendRequest() {
  const url = urls.proxyRequestSimultaneous
  const body = {
    requests: Object.keys(urls.rates).map(currency => {
      return {
        method: 'get',
        id: currency,
        url: urls.rates[currency],
      }
    }),
  }

  const response = await Network.sendPostRequest(url, body)
  return response
}

function parseResponse(response) {
  if (
    response &&
    response.status.code === 200 
  ) {
    const rawData = response.response
    const appData = Formatter.formatRates(rawData)

    return {
      statusCode: 200,
      data: appData,
    }
  }
  return Network.defaultResponseParsing(response)
}

export { getRates }
